import { Component, Input } from '@angular/core';

@Component({
  selector: 'fgb-games-nav',
  templateUrl: './games-nav.component.html',
  styleUrl: './games-nav.component.scss'
})
export class GamesNavComponent {
  @Input() routeLink: string;
}
